import { useAuth } from '../contexts';

/**
 * Centralized permissions hook.
 * Replaces scattered role checks across components.
 */
export const usePermissions = () => {
  const auth = useAuth();
  const user = auth?.user;
  const role = user?.role;

  const isSuperAdmin = role === 'superadmin';
  const isAdmin = role === 'admin' || role === 'superadmin';
  const isOperator = role === 'operator';
  const isInstaller = role === 'installer';
  const isQualityControl = role === 'quality_control';

  // Can create/edit/delete appointments
  const canManageAppointments = isSuperAdmin || role === 'admin' || isOperator;

  // Can manage users and teams
  const canManageUsers = isSuperAdmin || role === 'admin';

  // Can view reports and activity logs
  const canViewReports = isSuperAdmin || role === 'admin' || isOperator;

  // Can start/stop work (only installers for their own appointments)
  const canTrackWork = isInstaller;

  // Can receive WebSocket notifications
  const canReceiveNotifications = isSuperAdmin || role === 'admin' || isOperator || isQualityControl || isInstaller;

  // Read-only mode (QC users)
  const isReadOnly = isQualityControl;

  // Check if user can start/stop work on a specific appointment
  const canStartStopWork = (appointmentInstallerId) => {
    return isInstaller && appointmentInstallerId === user?.id;
  };

  // Check if user can edit a specific appointment's start address
  const canEditStartAddress = (appointmentInstallerId) => {
    return canManageAppointments || (isInstaller && appointmentInstallerId === user?.id);
  };

  return {
    user,
    role,
    isSuperAdmin,
    isAdmin,
    isOperator,
    isInstaller,
    isQualityControl,
    isReadOnly,
    canManageAppointments,
    canManageUsers,
    canViewReports,
    canTrackWork,
    canReceiveNotifications,
    canStartStopWork,
    canEditStartAddress,
  };
};
